import intl from '@alife/react-intl-universal';
// import intl from '../../lib/index';

export default {
  getMessage() {
    return intl.get('MESSAGE_NOT_IN_COMPONENT');
  }
};


// WEBPACK FOOTER //
// ./src/util.js